module.exports = __webpack_public_path__ + "media/images/icon__infoBox--rb-gray@3x-4bd14ca45608fbe74a85eade51631235.png";